<template>
  <div
    v-if="property.type === 'title'"
    :style="{ position: 'relative'}"
    @mouseenter="titleHover = true"
    @mouseleave="titleHover = false"
  >
    <title-editor
      v-if="!property.loading"
      :value="toSend[0] === undefined ? '' : toSend[0]"
      auto-focus
      @update:value="handleTextUpdate"
    />
    <div
      v-if="property.loading"
      :style="{ padding: '0 1.4rem', fontSize: '2em', marginBlockEnd: '0.67em', display: 'flex', alignItems: 'center', minHeight: '4rem', border: `1px solid ${$colors.grey.lighten3}`, borderRadius: '.4rem' }"
    >
      <div
        class="_left"
        :style="{ display: 'flex' }"
      >
        <c-icon
          type="pro"
          :color="$colors.purple.base"
        />
        <div :style="{ fontSize: $fontSizes[5], margin: '0 .4rem', color: $colors.purple.base, display: 'flex', alignItems: 'center' }">
          AI is writing...
        </div>
        <c-icon
          type="loading"
          spin
          :color="$colors.purple.base"
        />
      </div>
      <div :style="{ marginLeft: 'auto' }">
        <c-button
          icon="close-circle"
          color="light"
          size="xs"
          :style="{ marginRight: '1rem'}"
          @click="$emit('cancel-click', property)"
        >
          Stop
        </c-button>
      </div>
    </div>
  </div>
  <property-item
    v-else
    :name="property.name"
    :loading="property.loading"
    :icon="getIconForType(property.type)"
    :label-style="{ marginTop: '.5rem' }"
    @cancel-click="$emit('cancel-click', property)"
  >
    <div v-if="valueToShow === 'inputType'">
      <c-focusable>
        <simple-text-editor
          :value="toSend[0]"
          :initial-content="toSend[0]"
          placeholder="Empty"
          disable-enter
          return-string-value
          @update:value="handleTextUpdate"
        />
      </c-focusable>
    </div>

    <div v-if="valueToShow === 'dateType'">
      <c-date-picker
        block
        :predefined="false"
        :value="{start: toSend[0], end: null}"
        @update:value="handleDateUpdate"
      />
    </div>

    <div v-if="['selectionType', 'multiType'].includes(valueToShow)">
      <c-select
        overlapping
        match-trigger-width
        :multiple="valueToShow === 'multiType'"
        :options="[...property.options, ...createdOptions]"
        :value="toSend"
        can-create-option
        @option-created="option => createdOptions.push(option)"
        @update:value="handlePredefinedUpdate"
      />
    </div>

    <div v-if="valueToShow === 'buttonType'">
      <c-focusable
        @click="handleCheckboxUpdate(!toSend[0])"
      >
        <c-checkbox
          :value="toSend[0]"
          :style="{ margin: '0px 6px 0px 0px', }"
        />
      </c-focusable>
    </div>
  </property-item>
</template>

<script>

import CButton from 'shared/components/CButton.vue';
import CCheckbox from 'shared/components/CCheckbox.vue';
import CDatePicker from 'shared/components/CDatePicker.vue';
import CFocusable from 'shared/components/CFocusable.vue';
import CIcon from 'shared/components/CIcon.vue';
import CSelect from 'shared/components/CSelect.vue';
import PropertyItem from 'shared/components/PropertyItem.vue';
import SimpleTextEditor from 'shared/components/SimpleTextEditor.vue';
import TitleEditor from 'shared/components/TitleEditor.vue';
import { getIconForType } from 'shared/services/notion-icons';

export default {
  name: 'PropertyUse',
  props: {
    property: { type: Object, required: true },
    valueToSend: { type: Object, required: true },
  },
  emits: ['update:value', 'cancel-click'],
  components: { SimpleTextEditor, TitleEditor, CCheckbox, CDatePicker, PropertyItem, CSelect, CFocusable, CButton, CIcon },
  data() {
    return { toSend: [], createdOptions: [], titleHover: false };
  },
  computed: {
    valueToShow() {
      if (['select', 'status'].includes(this.property.type)) {
        return 'selectionType';
      }

      if (['multi_select'].includes(this.property.type)) {
        return 'multiType';
      }

      if (['checkbox'].includes(this.property.type)) {
        return 'buttonType';
      }

      if (['date'].includes(this.property.type)) {
        return 'dateType';
      }

      if (['title'].includes(this.property.type)) {
        return 'title';
      }

      return 'inputType';
    },
  },
  methods: {
    getIconForType,
    handlePredefinedUpdate(value) {
      this.toSend = value;
      this.$emit('update:value', this.toSend);
    },
    toggleCheck() {
      this.toSend = [!this.toSend[0]];
      this.$emit('update:value', this.toSend);
    },
    handleTextUpdate(value) {
      if (this.property.type === 'number') {
        value = parseFloat(value).toString();
        value = value === 'NaN' ? '' : value;
      }
      this.toSend = [value];
      this.$emit('update:value', this.toSend);
    },
    handleDateUpdate(value) {
      this.toSend = [value.start];
      this.$emit('update:value', this.toSend);
    },
    handleCheckboxUpdate(value) {
      this.toSend = [value];
      this.$emit('update:value', this.toSend);
    },
  },
  watch: {
    valueToSend() {
      this.toSend = this.valueToSend;
    },
  },
  created() {
    this.toSend = this.valueToSend;
  },
};
</script>

<style scoped type="text/scss">
</style>
